import * as React from "react";

export const Section01 = () => (
  <div className="content">
    <div className="template-block">
      <img
        className="large-img"
        src="/images/resources/habits-single-page-german/onepage-habits-german.png"
        alt="Habits: Single Page Version: German Translation"
      />
    </div>
  </div>
);
